import React, { Component, Dispatch } from 'react';
import { IAppState, IAction } from '../../../models/action/core';
import { ILoginAnnouncementModalProp, ILoginAnnouncementModalState } from '../../../models/components/login-announcement-modal-props';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import Moment from 'moment';
import Loading from '../../../components/loading/loading';
import { Log, Level, Logger } from 'ng2-logger';
import { SecureImage } from '../../../components/core/secureImage';
import { UserType } from '../../../models/enums/userType';
import Translator from '../../../core/i18n';
import ContentLoader from 'react-content-loader';

const _logger = Log.create('login.tsx');
const T = Translator.create();
let _common: Common;
class CLoginAnnouncementModal extends Component<ILoginAnnouncementModalProp, ILoginAnnouncementModalState> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public state: ILoginAnnouncementModalState = {
        isReadApproved: false
    };



    public setHeaderState = (value: string) => {
        this.props.headerState(value);
    };

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    public getUserType = (userTypeId: UserType) => {
        if (userTypeId === UserType.Student) {
            return T.t('r_gen_student');
        }
        if (userTypeId === UserType.User) {
            return T.t('r_gen_user');
        }
        if (userTypeId === UserType.Teacher) {
            return T.t('r_gen_teacher');
        }
        if (userTypeId === UserType.Parent) {
            return T.t('r_gen_parent');
        }
        if (userTypeId === UserType.Guest) {
            return T.t('r_gen_guest');
        }
    };

    readApproved = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            this.setState({ isReadApproved: event.target.checked });
        }
    };

    onSubmit() {
        this.props.onClickChangeAnnouncement();
    }

    callBackFunction = (value: any) => {
        if (value) {
        }
    };

    public render() {

        const subject = this.props.selectedAnnouncement ? this.props.selectedAnnouncement.subject : '';
        this.setHeaderState(subject);

        return (
            <div className="announcement-detail-content" style={{ minHeight: 250 }}>
                <Loading spinnerId={'getLoginAnnouncementModal'} >
                    <ContentLoader
                        speed={1}
                        width={700}
                        height={150}
                        viewBox="0 0 700 150"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                        <circle cx="19" cy="25" r="18" />
                        <rect x="40" y="12" rx="5" ry="5" width="220" height="10" />
                        <rect x="40" y="29" rx="5" ry="5" width="220" height="10" />

                        <rect x="280" y="12" rx="5" ry="5" width="220" height="10" />
                        <rect x="280" y="29" rx="5" ry="5" width="220" height="10" />

                        <rect x="0" y="60" rx="0" ry="0" width="165" height="7" />
                        <rect x="0" y="80" rx="0" ry="0" width="680" height="10" />
                        <rect x="0" y="97" rx="0" ry="0" width="680" height="10" />
                        <rect x="0" y="114" rx="0" ry="0" width="680" height="10" />
                    </ContentLoader>
                </Loading>
                {this.props.selectedAnnouncement ? (
                    <div id="getLoginAnnouncementModal_Content">
                        <div className="user-info d-flex flex-wrap pt-0 mt-2">
                            {this.props.selectedAnnouncement.fromAvatarPath ? (
                                <SecureImage
                                    style={{ borderRadius: 100, minWidth: 40, minHeight: 40 }}
                                    class={'userProfile'}
                                    imageUrl={this.props.selectedAnnouncement.fromAvatarPath}

                                />
                            ) : (
                                <img src={_common.GetDefaultLogos('avatar')} />
                            )}
                            <span className="ml-3 mr-3">{this.props.selectedAnnouncement.fromDisplayName}</span>
                            <i className="material-icons mr-4">arrow_forward</i>
                            {this.props.selectedAnnouncement.contextHeaders && this.props.selectedAnnouncement.contextHeaders.length > 0
                                ? this.props.selectedAnnouncement.contextHeaders.map((context: any, headerIndex: any) => {
                                    return (
                                        <button key={headerIndex} className="category-tag-circle tag-gray" style={{ cursor: 'default' }}>
                                            {context.header + ' '}({this.getUserType(context.userType)})
                                        </button>
                                    );
                                })
                                : ''}
                        </div>
                        <div className="announcement-stats border-bottom pb-3 mb-4 mt-2" />
                        <div className="date d-inline-block">
                            {this.props.selectedAnnouncement.createdDate ? (
                                <span>
                                    {T.t('r_announcement_date').replace('{0}', Moment(this.props.selectedAnnouncement.createdDate.toString()).format(_common.findDateFormat(this.props.userPreferences, true)))}
                                </span>
                            ) : ''}
                        </div>
                        {/* <div className="d-inline-block">
                            <div className="tag-program ml-2 text-center">{T.t('r_announced')}</div>
                        </div> */}
                        <div className="announcement-content">
                            <p className={ (!_common.isArabic(this.props.selectedAnnouncement.content,  document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.selectedAnnouncement.content }} />
                        </div>
                        <div className="mt-4 mb-4 border-bottom" />
                        <div className="upload-files-name">
                            {this.props.selectedAnnouncement.files.map((file: any, fileIndex: any) => (
                                <button
                                    key={fileIndex}
                                    className="file-name"
                                    onClick={this.clickToDownload}
                                    data-filepath={file && file.path}
                                    data-filename={file && file.fileName}
                                >
                                    <i className="mr-1 material-icons" style={{ verticalAlign: 'middle' }}>
                                        attach_file
                                    </i>
                                    {file.fileName}
                                    <span style={{ verticalAlign: 'inherit' }}>
                                        {_common.BytesToSize(file ? parseInt(file.size, 10) : 0)}
                                    </span>
                                </button>
                            ))}
                        </div>
                        {this.props.selectedAnnouncement.files.length > 0 ? (
                            <div className="upload-file-display">
                                <div className="row">
                                    {this.props.selectedAnnouncement.files.map((file: any, fileIndex: any) =>
                                        /\.((jpe?g)|(png)|(gif))(\?|$)/gi.test(file.fileName) ? (
                                            <div key={fileIndex} className="col-md-3">
                                                <SecureImage imageUrl={file.path} />
                                            </div>
                                        ) : (
                                            ''
                                        )
                                    )}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {/* Announcement enrollments */}
                        {!this.props.isLogin ? null :
                           <>
                            {this.props.selectedAnnouncement!.showReadConfirmation ?
                                <div className="mini-btn mt-4 ml-auto">
                                    <div className="tick-radio position-absolute">
                                        <input
                                            onChange={this.readApproved}
                                            type="checkbox"
                                            checked={this.state.isReadApproved}
                                            name="demo"
                                            defaultValue="one"
                                            id="radio-vc"
                                            className="form-radio mr-2"
                                        />
                                        {T.t('r_gen_read_approve')}
                                    </div>
                                    <button
                                        onClick={() => { this.onSubmit() }}
                                        type="button"
                                        style={{ float: 'inline-end' }}
                                        className="btn btn-green mt-md-0 mt-2 mb-md-0 mb-2"
                                        disabled={!this.state.isReadApproved}
                                    >
                                        {this.props.leftAnnouncementCount !== 0 ? <span className="badge badge-pill badge-light badge-home-announcement">{this.props.leftAnnouncementCount}</span> : ''}
                                        {this.props.leftAnnouncementCount !== 0 ? T.t('r_continue') : T.t('r_finish')}
                                        <i className="material-icons small ml-2">arrow_forward</i>
                                    </button>
                                </div>
                            :
                                <div className="mini-btn mt-4 ml-auto">
                                    <button
                                        onClick={() => this.props.onClickChangeAnnouncement()}
                                        type="button"
                                        style={{ float: 'inline-end' }}
                                        className="btn btn-green mt-md-0 mt-2 mb-md-0 mb-2"
                                    >
                                        {this.props.leftAnnouncementCount !== 0 ? <span className="badge badge-pill badge-light badge-home-announcement">{this.props.leftAnnouncementCount}</span> : ''}
                                        {this.props.leftAnnouncementCount !== 0 ? T.t('r_continue') : T.t('r_finish')}
                                        <i className="material-icons small ml-2">arrow_forward</i>
                                    </button>
                                </div>
                                }</>
                        }
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ILoginAnnouncementModalProp): ILoginAnnouncementModalProp => {
    if (!state) {
        return ownProps;
    }

    const newProps: ILoginAnnouncementModalProp = Object.assign({}, ownProps, {
        isLogin: state.login.identitiy.isLogin,
        selectedAnnouncement: state.announcement.selectedAnnouncement,
        organizationId: state.login.login.organizationId,
        selectedAnnouncementIsLoaded: state.announcement.selectedAnnouncementIsLoaded,
        userPreferences: state.profile.userPreferences,

    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.announcement.selectedAnnouncement === prev.announcement.selectedAnnouncement &&
        next.announcement.selectedAnnouncementIsLoaded === prev.announcement.selectedAnnouncementIsLoaded &&
        next.profile.userPreferences === prev.profile.userPreferences &&
        next.login.login.organizationId === prev.login.login.organizationId&&
        next.login.identitiy.isLogin === prev.login.identitiy.isLogin
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const LoginAnnouncementModal = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual,
    }
)(CLoginAnnouncementModal);

export default LoginAnnouncementModal;
